import React, { useState, useEffect, useRef } from 'react'

import classes from './CanvasCharacter.module.css'
import clsx from 'clsx';
import Button from '@cmp/shared/Button/Button';
import Texts from 'react-sdk/Texts';
import { FaForward, FaPause, FaPlay } from 'react-icons/fa6';
import { pickRandom } from 'react-sdk/utils';
import { set } from 'mobx';

// si char_id et pas sequence_element : on affiche un perso en neutre (éventuellement loop de qqs attitudes)
// si char_id + sequence_element :
//   * si c'est le perso principal, on l'affiche, on le fait parler, on affiche le dial
//   * si c'est un perso secondaire (dans sequence_element.otherCharacters), on l'affiche en neutre

const POSITIONS = {
  LEFT: "LEFT",
  RIGHT: "RIGHT",
}

const TAGS = {
  HIDDEN: "HIDDEN",
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE"
}

const CanvasCharacter = ({ char_id, sequence_element, onEnd, className, forceShow = false }) => {

  const charRef = useRef(null)
  const charRawDataRef = useRef(null)
  const canvasRef = useRef(null)


  const [subtitle, setSubtitle] = useState(null);
  const [paused, setPaused] = useState(false);
  const [tag, setTag] = useState(TAGS.HIDDEN);
  const [position, setPosition] = useState(POSITIONS.LEFT);
  const [index, setIndex] = useState(0);
  const [styleTransform, setStyleTransform] = useState({});

  useEffect(() => {
    charRef.current = window.SpeechAPI.createCanvasCharacter(char_id, canvasRef.current)
    if (charRef.current)
      charRawDataRef.current = charRef.current.entity.m_components.m_map.get("succubus.character.data.CharacterData").rawObject ?? { name: char_id, color: "#006DB8", type: "default" }
    else {
      charRawDataRef.current = { name: char_id, color: "#006DB8", type: "default" }
    }

    return () => {
      charRef.current.stop()
      charRef.current.delete()
      charRef.current = null
      charRawDataRef.current = null
    }
  }, []);


  /* à chaque changement de sequence_element */
  useEffect(() => {
    if (!charRef.current) return

    if (char_id && !sequence_element) {
      charRef.current.enableBackToNeutral(false)
      charRef.current.playContent("", "", "neutre", "", () => { })
    }

    if (char_id && sequence_element) {
      const { Text, TextTimings, AttitudeTimings, Audio, Character, leftCharacters, rightCharacters } = sequence_element.raw

      if (leftCharacters && leftCharacters.includes(char_id)) {
        if (leftCharacters.includes(",")) {
          let split = leftCharacters.split(",")
          for (let i = 0; i < split.length; i++) {
            if (split[i].includes(char_id)) {
              setIndex(i)
              break
            }
          }
        }
        else {
          setIndex(0)
        }
        setPosition(POSITIONS.LEFT)

        handleCharDial(Text, TextTimings, AttitudeTimings, Audio, Character, leftCharacters, rightCharacters)
      }
      else if (rightCharacters && rightCharacters.includes(char_id)) {
        if (rightCharacters.includes(",")) {
          let split = rightCharacters.split(",")
          for (let i = 0; i < split.length; i++) {
            if (split[i].includes(char_id)) {
              setIndex(i)
              break
            }
          }
        }
        else {
          setIndex(0)
        }
        setPosition(POSITIONS.RIGHT)

        handleCharDial(Text, TextTimings, AttitudeTimings, Audio, Character, leftCharacters, rightCharacters)
      }
      else {
        setTag(TAGS.HIDDEN)
      }


    }
  }, [char_id, sequence_element]);

  const handleCharDial = (Text, TextTimings, AttitudeTimings, Audio, Character, leftCharacters, rightCharacters) => {
    if (Character === char_id) {
      charRef.current.unfreeze()
      if (sequence_element.Type === "choice_title") {
        charRef.current.setTextCallback(subtitle => setSubtitle(null))
      }
      else {
        charRef.current.setTextCallback(subtitle => setSubtitle(subtitle))
      }

      charRef.current.playContent(Text, TextTimings, AttitudeTimings, Audio || "", () => {
        if (Audio) {
          setSubtitle(null);

          if (onEnd) onEnd();
        }
      })

      setTag(TAGS.ACTIVE)
    }
    else {
      charRef.current.unfreeze()
      if (char_id !== Character)
        charRef.current.playContent("", "", "", "", () => { })

      setTag(TAGS.INACTIVE)
    }
  }

  function handleSkip() {
    const { Audio } = sequence_element.raw

    if (!Audio) {
      onEnd && onEnd();
    }
    else {
      charRef.current.skipSegment()
    }
  }

  function togglePause(e) {
    e.stopPropagation()
    if (paused) {
      charRef.current.resume()
    }
    else {
      charRef.current.pause()
    }

    setPaused(p => !p)
  }

  useEffect(() => {


  }, [index])


  useEffect(() => {


    let pos = -50 + index * 180
    if (position === POSITIONS.RIGHT) pos = pos * -1 

    setStyleTransform({
      transform: `translateX(${pos}px) translateY(220px) scaleX(${position === POSITIONS.RIGHT ? -1 : 1})`
    })

  }, [tag, position, index])

  return (
    <div className={clsx(classes.CanvasCharacter, classes[char_id], classes[forceShow ? TAGS.ACTIVE : tag], classes[charRawDataRef?.current?.type], classes[position], classes["char_" + index], className)} >

      <div className={classes.canvas_ctnr_ctnr} style={styleTransform}>
        <div className={classes.canvas_ctnr}>
          <canvas ref={canvasRef} className={classes.canvas}></canvas>
        </div>
      </div>

      {subtitle &&
        <div className={classes.subtitle} onClick={handleSkip}>
          <div className={classes.char_name} style={{ background: charRawDataRef.current.color }}>{charRawDataRef.current.name}</div>
          <div className={classes.subtitle_text} dangerouslySetInnerHTML={{ __html: subtitle }} />

          <FaForward className={classes.forward_icon} />

          {/* {sequence_element.raw.Audio &&
            <Button
              className={classes.pause_btn}
              onClick={togglePause}
              icon={paused ? <FaPlay /> : <FaPause />}
            />} */}
        </div>}
    </div>
  );
};

export default CanvasCharacter;
